import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setConfigurationListModal } from '../actions/modalActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import ConfigurationListItem from '../../components/ConfigurationListItem'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'

class ConfigurationListModal extends Component {
    constructor(props) {
        super(props);
        this.cancelTap = this.cancelTap.bind(this);
        this.removeTap = this.removeTap.bind(this);
        this.processTouchTap = this.processTouchTap.bind(this);
    }

    cancelTap() {
        this.props.setConfigurationListModal([], false, 'default');
    }

    removeTap() {
        this.processTouchTap(null);
        this.props.setConfigurationListModal([], false, 'default');
    }

    processTouchTap(param) {
        const callback = this.props.configurationListModal.callback;
        const dispatch = this.props.configurationListModal.dispatch;

        let callbackParams = [param];

        if (this.props.configurationListModal.callbackparams !== undefined) {
            this.props.configurationListModal.callbackparams.map(param => {
                callbackParams.push(param);
                return '';
            })
        }

        this.props.setConfigurationListModal([], false, 'default');

        if (callback !== null) {
            if (dispatch !== null) {
                dispatch(callback.apply(this, callbackParams));
            } else {
                callback.apply(this, callbackParams);
            }
        }

    }

    render() {

        return (
            <Modal className='configurationListModal'
                contentLabel=""
                isOpen={this.props.configurationListModal.show}
                style={properties.configurationListModalStyle}
            >
                <div className="configurationListModal_header">
                    <div className="header_top">
                    {getTranslation(resource.CONFIGURATIONS)}
                    </div>
                </div>
                <div className="configurationListModal_content">
                    <div className="configurationList" >
                        {
                            this.props.configurationListModal.listvalues.map(val =>
                                <ConfigurationListItem
                                    key={val.Config.ArticleConfigurationStepId}
                                    Config={val.Config}
                                    Callback={this.processTouchTap}
                                />
                            )
                        }
                    </div>
                </div>
                <div className="configurationListModal_footer">
                    <button className="btnCancel" onClick={this.cancelTap} >
                    {getTranslation(resource.CANCEL)}
                    </button>
                </div>

            </Modal>
        )
    }
}

ConfigurationListModal.propTypes = {
}


function mapStateToProps(state) {
    return {
        configurationListModal: state.modalState.configurationListModal,
    }
}

export default connect(mapStateToProps, {
    setConfigurationListModal,
    getTranslation,
})(ConfigurationListModal)



// WEBPACK FOOTER //
// src/modal/components/ConfigurationListModal.jsx